import { isDefined } from '$lib/helpers/is-defined.helper';

export const toStringParams = <T>(params: T): string =>
    Object.entries(params)
        .filter(([, value]) => isDefined(value))
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
